var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 610.75 598.69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    transform: "translate(-980.25 -601.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1328.91 741.37a54.25 54.25 0 0 1 50.09 33.63 54.71 54.71 0 0 1 -11.75 59.41 54.06 54.06 0 0 1 -38.34 16z",
    fill: "#0c0c0c",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1093.66 806.91a54 54 0 0 1 15.81-38.4 54.6 54.6 0 0 1 89 17.23 53.91 53.91 0 0 1 4.23 20.73z",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204.14 790.91a59.62 59.62 0 1 1 119.24-.77z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1104.92 982.47a86 86 0 0 1 52.92-79.42 85.83 85.83 0 0 1 118.52 79.42z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1276.14 1199a103.75 103.75 0 1 1 207.49 0z",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1482 873.26a108.74 108.74 0 1 1 0 217.48z",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1370.14 869.86a108.74 108.74 0 1 1 217.47 0z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1477.75 984.83-1 105.92-105.93-1a105.94 105.94 0 0 1 106.93-104.92z",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "m980.64 1200v-96.54h96.53a96.54 96.54 0 0 1 -96.53 96.54z",
    fill: "#0c0c0c",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1371.91 874.29 105.31-.09.08 105.33a105.32 105.32 0 0 1 -105.39-105.24z",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1065.29 706.63h-85v-85a85 85 0 0 1 85 85z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1089.66 1044.53a54.51 54.51 0 0 1 -54.51 54.52h-54.51v-109.05h54.51a54.51 54.51 0 0 1 54.51 54.53z",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1265.49 916.52a43.32 43.32 0 1 1 43.32-43.32 43.31 43.31 0 0 1 -43.32 43.32z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1309.07 1020a23.66 23.66 0 1 1 23.66-23.65 23.65 23.65 0 0 1 -23.66 23.65z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1497.64 1157a32.5 32.5 0 1 1 32.49-32.5 32.49 32.49 0 0 1 -32.49 32.5z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1076.83 998.92a23.88 23.88 0 1 1 23.87-23.87 23.88 23.88 0 0 1 -23.87 23.87z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1484.61 738.3a24.92 24.92 0 1 1 24.92-24.92 24.92 24.92 0 0 1 -24.92 24.92z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1541.26 771.22a32.79 32.79 0 1 1 32.79-32.79 32.79 32.79 0 0 1 -32.79 32.79z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1520.36 675a10.83 10.83 0 1 1 10.82-10.83 10.83 10.83 0 0 1 -10.82 10.83z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1439 623.22a10.83 10.83 0 1 1 10.83-10.83 10.83 10.83 0 0 1 -10.83 10.83z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1424.73 678.46a14.32 14.32 0 1 1 14.27-14.32 14.32 14.32 0 0 1 -14.27 14.32z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1034.28 775.89a33 33 0 1 1 33-33 33 33 0 0 1 -33 33z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1312.81 852.06a54.25 54.25 0 0 1 50.09 33.66 54.56 54.56 0 0 1 -29.34 71.28 54 54 0 0 1 -20.75 4.15z",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1533.13 1090.64a54.06 54.06 0 0 1 38.34 16 54.6 54.6 0 0 1 -17.59 88.92 54 54 0 0 1 -20.75 4.15z",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1295.63 1095a105 105 0 1 1 -210 0z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1086.14 1090.94a104.25 104.25 0 1 1 208.49 0z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m980.25 768.55a108.74 108.74 0 1 1 .32 217.45z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1456.75 724.1a48.85 48.85 0 1 1 -97.7.47z",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1093.66 919.77v-109h109a109 109 0 0 1 -109 109z",
    opacity: 0.36
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1227.14 838.79a21.45 21.45 0 1 1 21.45-21.45 21.45 21.45 0 0 1 -21.45 21.45z",
    fill: "#0c0c0c",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1376.91 1019a37 37 0 1 1 37-37 37 37 0 0 1 -37 37z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1332.73 1094a37 37 0 1 1 37-37 37 37 0 0 1 -37 37z",
    fill: "#fff",
    opacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP51);
export default __webpack_public_path__ + "static/media/p51.9a8664d38b3c00aa06814c706dabde59.svg";
export { ForwardRef as ReactComponent };